import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'
import './styles/index.scss'

const app = createApp(App)

// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(ElementPlus, {
  locale: zhCn
})
app.use(router)
app.use(store)

// 忽略 ResizeObserver 循环警告（这是浏览器的一个已知问题，不影响功能）
const resizeObserverErrorRegex = /ResizeObserver loop completed with undelivered notifications/i

// 拦截 console.error
const originalError = console.error
console.error = (...args) => {
  const message = args[0]
  if (typeof message === 'string' && resizeObserverErrorRegex.test(message)) {
    return
  }
  originalError.apply(console, args)
}

// 全局错误处理：忽略 ResizeObserver 警告
window.addEventListener('error', (event) => {
  if (event.message && resizeObserverErrorRegex.test(event.message)) {
    event.stopImmediatePropagation()
    return false
  }
}, true)

// 全局未捕获的 Promise 错误处理
window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason
  if (reason && typeof reason === 'string' && resizeObserverErrorRegex.test(reason)) {
    event.preventDefault()
    return false
  }
})

// 初始化系统配置，成功后才能挂载应用
async function initApp() {
  try {
    await store.dispatch('system/fetchConfig')
    app.mount('#app')
  } catch (error) {
    console.error('系统配置加载失败:', error)
    ElMessage({
      message: '系统配置加载失败，请刷新页面重试',
      type: 'error',
      duration: 0,
      showClose: true
    })
    // 显示错误信息，但不阻止应用挂载（避免白屏）
    app.mount('#app')
  }
}

initApp()
